import "./styles.scss";

import { useNavigate } from "react-router-dom";

import { Text, Button } from "@fragments";
import {
    IconArrowLeft,
    IconCheck,
    IconX,
    IconBrandWhatsapp,
    IconClipboardCheck,
} from "@tabler/icons-react";

/**
 * Floating review bar shown when the answers page is opened from a mentoring
 * enrollment (EnrollmentDetailView → "Visualizar aplicação"). Borrows the
 * community "create post" floater design: fixed, centered, rounded card that
 * slides up from the bottom.
 *
 * `canReview` (status === "pending") adds the Approve/Reject actions. Those are
 * placeholders until the review flow (PATCH …/enrollments/{id}/review, ClickUp
 * 868jxkz4p stage 4) is wired — they mirror the toast used elsewhere.
 */
export default function MentoringReviewBar({ returnTo, canReview, phone }) {
    const navigate = useNavigate();

    function goBack() {
        if (returnTo) navigate(returnTo);
    }

    // wa.me expects digits only — strip the leading "+" and any spacing.
    function openWhatsApp() {
        const digits = String(phone ?? "").replace(/\D/g, "");
        if (digits) window.open(`https://wa.me/${digits}`, "_blank", "noopener");
    }

    function reviewPlaceholder() {
        window.setSnackbar?.("Aprovação e recusa da mentoria chegam na etapa 4.");
    }

    return (
        <div
            className="mentoring-review-bar is-visible"
            role="region"
            aria-label="Revisão da aplicação"
        >
            <div className="mentoring-review-bar__card">
                <div className="mentoring-review-bar__title">
                    <span className="mentoring-review-bar__title-icon">
                        <IconClipboardCheck size={18} />
                    </span>
                    <div className="mentoring-review-bar__title-text">
                        <Text.span contrast={9} weight={500}>Revisão da aplicação</Text.span>
                        <Text.span contrast={5}>
                            {canReview ? "Aprove ou recuse esta inscrição" : "Inscrição da mentoria"}
                        </Text.span>
                    </div>
                </div>

                <div className="mentoring-review-bar__actions">
                    <Button
                        size="small"
                        color="overlay"
                        variant="rounded"
                        startIcon={<IconArrowLeft size={16} />}
                        onClick={goBack}
                        tooltip="Voltar à inscrição"
                        preventLoading
                    >
                        Voltar
                    </Button>

                    {phone && (
                        <Button
                            size="small"
                            color="overlay"
                            variant="rounded"
                            icon={<IconBrandWhatsapp size={16} />}
                            onClick={openWhatsApp}
                            tooltip="Chamar no WhatsApp"
                            preventLoading
                        />
                    )}

                    {canReview && (
                        <>
                            <Button
                                size="small"
                                color="error"
                                startIcon={<IconX size={16} />}
                                onClick={reviewPlaceholder}
                                preventLoading
                                discreet
                            >
                                Recusar
                            </Button>
                            <Button
                                size="small"
                                color="success"
                                startIcon={<IconCheck size={16} />}
                                onClick={reviewPlaceholder}
                                preventLoading
                            >
                                Aprovar
                            </Button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
